// src/app/router/RequireSubscription.tsx
import { Outlet } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";
import { Box, CircularProgress } from "@mui/material";
import Restricted from "../layout/account/Restricted";

interface RequireSubscriptionProps {
  tier?: 'simple' | 'advanced' | 'professional';
}

const RequireSubscription = ({ tier }: RequireSubscriptionProps) => {
  const { hasActiveSubscription, hasSubscription, loading } = useSubscription();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If no specific tier required, just check for any active subscription
  if (!tier) {
    if (!hasActiveSubscription) {
      return (
        <Restricted 
          title="Subscription Required"
          message="An active subscription is required to access this page. Please subscribe to unlock all features."
        />
      );
    }
    return <Outlet />;
  }

  // Check specific tier requirement
  const tierNames = {
    simple: 'Simple',
    advanced: 'Advanced',
    professional: 'Professional'
  };

  if (!hasSubscription(tier)) {
    return (
      <Restricted 
        title={`${tierNames[tier]} Tier Required`}
        message={`This feature requires a ${tierNames[tier]} tier subscription or higher. Please upgrade your plan to access this page.`}
      />
    );
  }

  return <Outlet />;
};

export default RequireSubscription;
